module.exports = new __parcel__URL__("arrow.46760de9.png").toString();